import { environment } from '@env/environment';
import { Settings } from 'ngx-drupal7-services';

export const drupal7Settings: Settings = {
  apiProtocol: 'https',
  apiEndPoint: 'api/v1',
  apiHost: environment.server7Url,
  language: 'und',
  requestTimeout: 200000,
};
